import React from 'react';
import NumberFormat from 'react-number-format';

interface NumberFormatCustomProps {
  inputRef: (instance: NumberFormat<any> | null) => void;
  onChange?: (value: any) => void;
  name: string;
}

const IntegerNumberFormat = (props: NumberFormatCustomProps) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange?.(values.value);
      }}
      decimalSeparator=","
      decimalScale={0}
      isNumericString
      allowNegative={false}
    />
  );
};

export default IntegerNumberFormat;
